import styled from 'styled-components';

export const PatternCodeContainer = styled.div`
  & .pt-item-edit-row {
    border: 1px solid transparent;
    border-radius: 10px;
    padding: 2px;
  }

  & .pt-item-edit-row:hover {
    border-color: #69B1FF;
  }

  & .pt-item-edit-row .addon-after > .ant-select-selector {
    background-color: #FAFAFA;
  }

  & .pt-item-edit-row .agg-input {
    width: 150px;
  }

  & .pt-item-edit-row .ant-select {
    width: 108px;
  }

  & .pt-item-edit-row .pt-code-input {
    width: calc(100% - 110px);
  }

  & .pt-item-edit-row .pt-code-input.agg-mode {
    width: calc(100% - 260px);
  }

  & .pt-item-edit-row .pt-code-input .ant-input-affix-wrapper {
    border-radius: 0;
  }
`;
